// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__6P7NN","itemTitle":"ClientEmergencyInfo_itemTitle__2tb_d","itemText":"ClientEmergencyInfo_itemText__dA5re"};